var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAvailabilityIcon = function SvgAvailabilityIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86.011,
    height: 79.599,
    viewBox: "0 0 86.011 79.599",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prices",
    transform: "translate(-192.744 598.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2049",
    "data-name": "Group 2049",
    transform: "translate(192.744 -598.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2837",
    "data-name": "Path 2837",
    d: "M280.772-463.389v.337h.192C280.9-463.165,280.834-463.275,280.772-463.389Z",
    transform: "translate(-233.466 536.161)",
    fill: "#ca0928"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2838",
    "data-name": "Path 2838",
    d: "M240.05-546.7a21.837,21.837,0,0,1,8.6-8.675v-4.72h-25.8v25.8h-8.6v-33.587l21.5-19.352,21.5,19.352V-558c.629-.055,1.264-.088,1.907-.088a21.675,21.675,0,0,1,6.694,1.057V-560.1h12.9l-43.006-38.705L192.744-560.1h12.9v34.4h25.8v-25.8h8.6Z",
    transform: "translate(-192.744 598.805)",
    fill: "#ca0928"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2839",
    "data-name": "Path 2839",
    d: "M301.556-514.56A17.169,17.169,0,0,0,284.394-497.4a17.169,17.169,0,0,0,17.162,17.163A17.169,17.169,0,0,0,318.719-497.4,17.169,17.169,0,0,0,301.556-514.56Zm6.076,13.144-3.252-.06a.537.537,0,0,1-.527-.547l0-.149c-.021-.889-.535-1.361-1.528-1.382h0c-1.237,0-1.391.7-1.4,1.234l-.032,1.741,2.9.054a.537.537,0,0,1,.527.547l-.06,3.242a.536.536,0,0,1-.165.377.535.535,0,0,1-.372.15l-2.906-.054-.033,1.734a6.387,6.387,0,0,1-.161,1.271l6.691.125a.539.539,0,0,1,.378.164.539.539,0,0,1,.15.383l-.061,3.242a.538.538,0,0,1-.537.527l-11.772-.22a.538.538,0,0,1-.527-.548l.06-3.242a.538.538,0,0,1,.537-.528h.013c.437,0,.556-.1.693-.37a2.5,2.5,0,0,0,.22-.887l.032-1.734-.873-.016a.537.537,0,0,1-.377-.164.537.537,0,0,1-.15-.383l.06-3.242a.538.538,0,0,1,.537-.527l.884.016.032-1.717a5.923,5.923,0,0,1,1.651-3.976,5.524,5.524,0,0,1,4.014-1.519h.128a5.626,5.626,0,0,1,5.772,5.729",
    transform: "translate(-42.397 -38.972)",
    fill: "#ca0928"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAvailabilityIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/availability-icon.f570ff48.svg";
export { ForwardRef as ReactComponent };